import React, { useEffect, useState, useId, useContext } from 'react';
import { buildSort, ContextPayload, SearchEngine } from '@coveo/headless';
import { sortFields } from '../controllers/sort-criteria';
import { ExtendedWindowType, headlessEngine } from '../engine';
import { SortCriteria } from '../controllers/sort-criteria';
import { CoveoContext } from './context';
import SecondCall from './second-call-context';

type SortProps = {
  sortByLabel: string;
  extraClasses?: string;
};

const initialCriterion = sortFields[0].criterion;
const initialContext = sortFields[0].context;

if (initialContext) {
  const context = CoveoContext();

  context?.set({
    sortingStrategy: initialContext.sortingStrategy
  } as ContextPayload);
}

const controller = buildSort(headlessEngine as SearchEngine, {
  initialState: { criterion: initialCriterion }
});

export const Sort = ({ sortByLabel, extraClasses }: SortProps) => {
  const [state, setState] = useState(controller.state);
  const secondCallContext = useContext(SecondCall);
  const id = useId();

  useEffect(() => {
    controller.subscribe(() => setState(controller.state));
  }, []);

  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const sort = sortFields.find(
      (field: SortCriteria) => field.title === e.target.value
    );

    const criterion = sort?.criterion;
    secondCallContext.setOriginalContext?.(undefined);
    if (criterion && sort?.context) {
      const context = CoveoContext();

      context?.set({
        sortingStrategy: sort.context.sortingStrategy
      } as ContextPayload);
    }

    controller.sortBy(criterion);

    const global = window as ExtendedWindowType;

    global.dataLayer?.push({
      event: 'sort_by',
      event_category: 'listing page interactions',
      event_action: 'sort by'
    });
  };

  const getCurrentCriterion = () => {
    const criterion = sortFields.find((field: SortCriteria) => {
      if (field.criterion?.by !== 'field') {
        return field.criterion?.by === state.sortCriteria;
      } else {
        return (
          state.sortCriteria ===
          `@${field.criterion?.field} ${field.criterion?.order}`
        );
      }
    })?.title;

    return criterion;
  };

  return (
    <div>
      <div className={`field field--select ${extraClasses || ''}`}>
        <label htmlFor={`coveo-select${id}`} className="field__label">
          {sortByLabel}
        </label>
        <select
          name={`coveo-select${id}`}
          id={`coveo-select${id}`}
          className="field__select"
          onChange={handleChange}
          value={getCurrentCriterion()}
        >
          {sortFields.map((field: SortCriteria, index: number) => (
            <option key={index} value={field.title}>
              {field.title}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};
